import {Col, Row} from "reactstrap";
import {Tooltip} from "@progress/kendo-react-tooltip";
import {deleteHostKey, mainMessages} from "../../../assets/text/MultilingualText";
import {DeleteIcon} from "../../common/icons";
import React, {useContext} from "react";
import {useLocalization} from "@progress/kendo-react-intl";
import UserContext from "../../common/UserContext";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";
import config from "../../../config";
import axios from "axios";

export default function PanelBarHeader(props) {
    const {
        title,
        transactionID,
        setShowGenericError
    } = props;

    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);

    const {
        setIsLoading,
        headerInfo,
        uniqueID,
        parentUniqueID,
        setHeaderInfo,
        onePerHostKey,
    } = useContext(GeneralContext);

    const {
        selectedProducts,
        setSelectedProducts,
    } = useContext(SelectedProductContext);

    const {
        assignedProducts,
        setAssignedProducts,
        unsavedAssignedChanges,
        setUnsavedAssignedChanges,
    } = useContext(AssignedProductContext);

     const localization = useLocalization();

    //delete selected and assigned products
    const saveDelete = () => {
        setShowGenericError(false)
        let products = []
        const host = assignedProducts.find(item => item.transaction_id === transactionID);
        host.products.forEach((product) => {
            products.push({
                'cart_id': product[uniqueID],
                'status': product.status
            })
        })


        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };
        setIsLoading(true);

        let body = {
            module: "FSA",
            sub_module: "CART",
            action: "DELETE",
            input_json: {
                fsa_id: headerInfo.fsa_id,
                products: products
            }
        }

        axios.delete(
            config.fsa_request_license.CART,
            {headers: headers, data: body}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data
                    setHeaderInfo(data['header_info'])

                    const host = assignedProducts.find(item => item.transaction_id === transactionID);
                    host.products.forEach((product) => {

                        //add back assign qty to selected product
                        const parentProduct = selectedProducts.find(item => item[uniqueID] === product[parentUniqueID]);
                        parentProduct.unassigned_quantity += product.assign_quantity
                        parentProduct.saved_assigned_quantity -= product.assign_quantity
                        parentProduct.assign_quantity = parentProduct[onePerHostKey] === "Y" ? 1
                            : parentProduct.unassigned_quantity === 1 ? 1
                                : null;

                        //remove product from unsaved changes if it exists
                        unsavedAssignedChanges.delete(product[uniqueID])
                    })
                    setSelectedProducts([...selectedProducts])
                    setUnsavedAssignedChanges(unsavedAssignedChanges)

                    const newAssignedProducts = assignedProducts.filter(host => host.transaction_id !== transactionID);
                    setAssignedProducts(newAssignedProducts)
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to delete product", error);
                setShowGenericError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <>
            <Row
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Col
                    style={{
                        flex: '0 0 auto',
                        width: 'auto'
                    }}
                >
                    <div
                        className={"k-h5"}
                        style={{
                            color: 'white',
                            margin: '0'
                        }}
                    >
                        {title}
                    </div>
                </Col>
                <Col>
                    <div
                        style={{
                            float: 'right'
                        }}
                    >
                        <Tooltip
                            anchorElement="target"
                            showCallout={true}
                            parentTitle={true}
                            openDelay={0}
                            position="top"
                        >
                            <div
                                title={localization.toLanguageString(deleteHostKey, mainMessages[siteLanguageDefault][deleteHostKey])}
                                onClick={saveDelete}
                            >
                                <DeleteIcon
                                    style={{
                                        cursor: 'pointer',
                                        color: 'white'
                                    }}
                                />
                            </div>
                        </Tooltip>
                    </div>
                </Col>
            </Row>
        </>
    )
}